export default "__VITE_ASSET__CcFg4phY__"